export var EOpportunityInquireType;
(function (EOpportunityInquireType) {
    EOpportunityInquireType["INTEREST"] = "INTEREST";
    EOpportunityInquireType["BUY"] = "BUY";
    EOpportunityInquireType["SELL"] = "SELL";
})(EOpportunityInquireType || (EOpportunityInquireType = {}));
